import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import NoImage from '../../assets/images/noimage.png';
import Dropzone from 'react-dropzone-uploader';
import SweetAlert from 'sweetalert2';
import { getinsight, ModalToggle, isOpenModal, isImageOpenModal, addinsight, updateinsightImage, deleteinsightImage, isPdfOpenModal, PdfstatusToggle, ImagestatusToggle, updateinsightPdf, isOpenStatusModal, statusToggle, updateInsightStatus, updateinsight, } from '../../store/insightSlice';

const InsightTable = () => {
  const storeVar = useSelector(state => state.insight)
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const Imagetoggle = () => dispatch(ImagestatusToggle());
  const Pdftoggle = () => dispatch(PdfstatusToggle());
  const statusModalToggle = () => dispatch(statusToggle());
  const [submit, setSubmit] = useState(false);
  const [stateStatus, setStateStatus] = useState('active');
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 100,
    offset: 0,
    currentPage: 1,
    status: 'ACTIVE',
    modalTitle: null,
    editState: false,
    insightId: '',
    title: '',
    tag: '',
    description: '',
    insightsDate: '',
    link: '',
    status: 'active',
    type: '',
    fileType: '',
  });

  useEffect(() => {
    dispatch(getinsight(formVar.limit, formVar.offset, formVar.status))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getinsight(formVar.limit, offset))
  };


  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      categoryId: data.id,
      modalTitle: 'Edit Insight',
      insightId: data._id,
      title: data.title,
      tag: data.tag,
      description: data.description,
      link: data.link || '',
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Insight',
      title: '',
      tag: '',
      description: '',
      insightsDate: '',
    }))
  }



  const submitInsight = () => {
    if (titleValid() || descriptionValid() || linkValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    if (formVar.editState) {
      dispatch(updateinsight(formVar.insightId, { title: formVar.title, tag: formVar.tag, description: formVar.description, fileType: formVar.fileType, link: formVar.link, type: formVar.type }))
    } else {
      dispatch(addinsight({ title: formVar.title, tag: formVar.tag, description: formVar.description, fileType: formVar.fileType, link: formVar.link, type: formVar.type }))
    }
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const descriptionValid = () => {
    if (!formVar.description) {
      return "Description is required";
    }
  }
  const linkValid = () => {
    if (formVar.fileType == 'link') {
      if (!formVar.link) {
        return "Link is required";
      }
    }
  }



  const filesValid = () => {
    if (!formVar.bannerFile) {
      return "Files is required";
    }
  }
  const ImageEditBannerModal = (data) => {
    dispatch(isImageOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      insightId: data._id,
      modalTitle: 'Update Icon',
      bannerFile: null,
      bannerImageURL: null
    }))
  }
  const PDFEditBannerModal = (data) => {
    dispatch(isPdfOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      insightId: data._id,
      modalTitle: 'Update Pdf',
      bannerFile: null,
      bannerImageURL: null
    }))
  }
  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };

  const submitImage = () => {
    if (filesValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    dispatch(updateinsightImage(formVar.insightId, formVar.bannerFile))
  }
  const submitPDF = () => {
    if (filesValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    dispatch(updateinsightPdf(formVar.insightId, formVar.bannerFile))
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteinsightImage(data._id,))
        }
      });
  }


  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }))
    dispatch(getinsight(formVar.limit, formVar.offset, e.target.value))

  };
  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true))
    setStateStatus(data.status)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      insightId: data._id,
    }))
  }

  const submitStatus = () => {
    dispatch(updateInsightStatus(formVar.insightId, stateStatus))
  }
  const onValueChange = (event) => {
    setStateStatus(event.target.value)
  }

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">

              </Col>
              <Col md="4">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.status} onChange={handleInputChange}>
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Insight
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Title</th>
                  <th scope='col'>Type</th>
                  <th scope='col'>Image</th>
                  <th scope='col'>PDF Uploaded</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.insightData?.map((item, index) => (
                  <tr key={item._id}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.type.toUpperCase()}</td>
                    <td className='w-20'>
                      {item.image ? <img className='w-10-r h-5-r' src={item.image} alt="" /> : <img className='w-10-r h-5-r' src={NoImage} alt="" />}
                    </td>
                    <td className={item.link ? 'font-success' : 'font-warning'}>{item.link ? 'Uploaded' : 'Pending'}</td>
                    <td>
                      {
                        item.status === 'active' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>{item.status.toUpperCase()}</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>{item.status.toUpperCase()}</span>
                          </span>
                        </>
                      }
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer font-success action-icon'>
                          <i className="fa fa-picture-o fa-lg" onClick={(e) => ImageEditBannerModal(item)} />
                          <div className="tooltipCustom">Update Image</div>
                        </div>
                        <div className='cursor-pointer font-warning action-icon'>
                          <i className="fa fa-file-pdf-o fa-lg" onClick={(e) => PDFEditBannerModal(item)} />
                          <div className="tooltipCustom">Update PDF</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-info action-icon'>
                          <i className="fa fa-toggle-on fa-lg" onClick={(e) => statusToggleModal(item)}></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalnews <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalnews > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalnews}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'xl'}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter Insight Title' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Tags</Label>
            <Input className="form-control" type="text" placeholder='Enter Insight Tag' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, tag: e.target.value }))} value={formVar.tag} />
            <Label className="col-form-label" for="recipient-name">Description</Label>
            <textarea rows={3} className="form-control" type="text" placeholder='Enter Insight Description' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, description: e.target.value }))} value={formVar.description} />
            {submit && descriptionValid() ? <span className='d-block font-danger'>{descriptionValid()}</span> : ""}
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Type</Label>
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.type} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, type: e.target.value }))}>
                  <option value='portfolio'>PORTFOLIO</option>
                  <option value='industry'>INDUSTRY</option>
                </Input>
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">File Type</Label>
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.fileType} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, fileType: e.target.value }))}>
                  <option value='pdf'>PDF</option>
                  <option value='link'>LINK</option>
                </Input>
              </Col>
            </Row>
            {formVar.fileType === 'link' && <>
              <Label className="col-form-label" for="recipient-name">Link</Label>
              <Input className="form-control" type="text" placeholder='Enter Insight Link' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, link: e.target.value }))} value={formVar.link} />
              {submit && linkValid() ? <span className='d-block font-danger'>{linkValid()}</span> : ""}
            </>}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitInsight }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

      <CommonModal isOpen={storeVar.isImageOpenModal} title={formVar.modalTitle} toggler={Imagetoggle} >
        <Form>
          <FormGroup>

            <Label className="col-form-label" for="recipient-name">Update Image</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="image/*"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: Imagetoggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitImage }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isPdfOpenModal} title={formVar.modalTitle} toggler={Pdftoggle} >
        <Form>
          <FormGroup>

            <Label className="col-form-label" for="recipient-name">Update PDF</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="application/pdf"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: Pdftoggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitPDF }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle} >
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input id='radioinline1' type='radio' className="radio_animated" name='radio1' checked={stateStatus === 'active'} onChange={onValueChange} value='active' />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>ACTIVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input id='radioinline3' type='radio' className="radio_animated" name='radio3' checked={stateStatus === 'pending'} onChange={onValueChange} value='pending' />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>PENDING</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default InsightTable;
